export default __webpack_public_path__ + "static/media/Weber.eae00e3f.svg";